import { getLocaleStore } from '@/i18n/index';
import type { IFont } from '../definition';
import CN_DEFAULT_FONT_FAMILY_NAME_TTF from './assets/AlibabaPuHuiTi-Regular.ttf';
import CN_DEFAULT_FONT_FAMILY_NAME_WOFF2 from './assets/AlibabaPuHuiTi-Regular.woff2';
import EN_DEFAULT_FONT_FAMILY_NAME_TTF from './assets/Poppins-Regular.ttf';
import EN_DEFAULT_FONT_FAMILY_NAME_WOFF2 from './assets/Poppins-Regular.woff2';

export const EN_DEFAULT_FONT_FAMILY_NAME = 'Poppins-Regular';
export const CN_DEFAULT_FONT_FAMILY_NAME = 'AlibabaPuHuiTi-Regular';
let defaultFontFamily: IFont | null = null;

export const setDefaultFontFamily = (name: string) => {
    defaultFontFamily = {
        id: name,
        name,
        ttf: `${name}_TTF`,
        woff2: `${name}_WOFF2`,
    };
};

const ALIBABA_PUHUITI_REGULAR_FONT = {
    id: CN_DEFAULT_FONT_FAMILY_NAME,
    name: CN_DEFAULT_FONT_FAMILY_NAME,
    ttf: CN_DEFAULT_FONT_FAMILY_NAME_TTF,
    woff2: CN_DEFAULT_FONT_FAMILY_NAME_WOFF2,
};

const POPPINS_REGULAR_FONT = {
    id: EN_DEFAULT_FONT_FAMILY_NAME,
    name: EN_DEFAULT_FONT_FAMILY_NAME,
    ttf: EN_DEFAULT_FONT_FAMILY_NAME_TTF,
    woff2: EN_DEFAULT_FONT_FAMILY_NAME_WOFF2,
};

/** 获取默认字体 */
export const DEFAULT_FONT_FAMILY = () => {
    if (defaultFontFamily) {
        return defaultFontFamily;
    }

    const locale = getLocaleStore().locale;

    if (locale !== 'zh-Hans') {
        return POPPINS_REGULAR_FONT;
    }

    return ALIBABA_PUHUITI_REGULAR_FONT;
};
